import { Helmet } from 'react-helmet';
import './references.style.scss'
import { ContainerComponent, ImageSwiper, ParagraphComponent, SubtitleComponent, TitleComponent, VideoPlayer } from '../../components';
import { Trans, useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player'

//@ts-ignore
import punionica1 from '../../assets/images/references/punionica1.jpeg';
//@ts-ignore
import punionica2 from '../../assets/images/references/punionica2.webp';
//@ts-ignore
import punionica3 from '../../assets/images/references/punionica3.webp';
//@ts-ignore
import punionica4 from '../../assets/images/references/punionica4.jpeg';

import { useVideoStore } from '../../store';
import { useEffect, useRef } from 'react';

function Punionica() {
  const { t, i18n } = useTranslation();
  const { currentVideo, videos } = useVideoStore();


  const videoRef = useRef<HTMLDivElement>(null);
  useEffect(() => { videoRef.current && videoRef.current.scrollIntoView({ behavior: "smooth", block: "end" },) });


  return (
    <>
      <div className="punionica" >
        <Helmet>
          <title>{t('punionica.meta.title')}</title>
          <meta name="description" content={t('punionica.meta.description')} />
        </Helmet>
        <ContainerComponent>
          <Trans>
            <h1><TitleComponent centered smaller style={{ marginTop: '3rem' }}>{t('punionica.title')}</TitleComponent></h1>
            <h3><SubtitleComponent>{t('punionica.subtitle')}</SubtitleComponent></h3>
            <ReactPlayer className="videoPlayer" playing={true} controls={true} autoPlay muted={true} url={'https://www.youtube.com/shorts/xBHd9-WvY6s'} />

          </Trans>

        {/* <div ref={videoRef}>
          {videos[0].preloaded ? <VideoPlayer /> : <ReactPlayer className="videoPlayer" playing={true} controls={true} autoPlay muted={true} url={"https://tesenergy.hr/videos/Projekt1.mp4"} />
          }
        </div> */}


        <ImageSwiper images={[punionica1, punionica2, punionica4, punionica3]} thumbs />

          <Trans>
            <div className="specifications">
              {/* <h3><SubtitleComponent medium white large semiBold>{t('punionica.specifications.title')}</SubtitleComponent></h3> */}
              <ParagraphComponent>{t('punionica.specifications.content')}</ParagraphComponent>
            </div>
            {/* <div className="phases">
              <div className="phaseNumber">1</div>
              <ParagraphComponent>{t('punionica.phases.1')}</ParagraphComponent>
              <ImageSwiper images={[f11, f12, f13, f14]} thumbs />
              <div className="phaseNumber">2</div>
              <ParagraphComponent>{t('punionica.phases.2')}</ParagraphComponent>
              <ImageSwiper images={[f21, f22, f23, f24, f25, f26]} thumbs />
              <div className="phaseNumber">3</div>
              <ParagraphComponent>{t('punionica.phases.3')}</ParagraphComponent>
              <ImageSwiper images={[f31, f32, f33, f34, f35, f36]} thumbs />
            </div> */}
          </Trans>
        </ContainerComponent >
      </div >
    </>
  )
}

export default Punionica